import { z } from 'zod';

const idString = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z0-9_-]+$/, 'Ids use letters, digits, "_" and "-" only');

export const projectIdSchema = idString.brand<'ProjectId'>();
export const scenarioIdSchema = idString.brand<'ScenarioId'>();
export const itemIdSchema = idString.brand<'ItemId'>();
export const categoryIdSchema = idString.brand<'CategoryId'>();
export const goalIdSchema = idString.brand<'GoalId'>();
export const investmentIdSchema = idString.brand<'InvestmentId'>();
export const keyDateIdSchema = idString.brand<'KeyDateId'>();

export type ProjectId = z.infer<typeof projectIdSchema>;
export type ScenarioId = z.infer<typeof scenarioIdSchema>;
export type ItemId = z.infer<typeof itemIdSchema>;
export type CategoryId = z.infer<typeof categoryIdSchema>;
export type GoalId = z.infer<typeof goalIdSchema>;
export type InvestmentId = z.infer<typeof investmentIdSchema>;
export type KeyDateId = z.infer<typeof keyDateIdSchema>;
